import Vue from "vue";
import VueRouter from "vue-router";
import Restaurants from "@/pages/restaurant/index.vue";
import GuestRestaurants from "@/pages/restaurant/guests.vue";
import RestaurantSettings from "@/pages/restaurant/settings.vue";
import RestaurantFoods from "@/pages/restaurant/foods.vue";
import RestaurantMenu from "@/pages/restaurant/menu.vue";
import RestaurantMenuGroups from "@/pages/restaurant/menuGroups.vue";
import RestaurantDelivery from "@/pages/restaurant/delivery.vue";
import RestaurantRecipes from "@/pages/restaurant/recipes";
import RestaurantGroceries from "@/pages/restaurant/groceries";
import RestaurantMealCategories from "@/pages/restaurant/meal-categories.vue";
import RestaurantGallery from "@/pages/restaurant/gallery.vue";
import Companies from "@/pages/company/index.vue";
import CompanyDelivery from "@/pages/company/delivery/index.vue";
import CompanyReport from "@/pages/company/report/index.vue";
import CompanyMenu from "@/pages/company/menu/index.vue";
import CompanyLimits from "@/pages/company/limits/index.vue";
import RestaurantLimits from "@/pages/restaurant/limits.vue";
import CategoryMenu from "@/pages/company/menu/category-menu";
import CategoryMenuGroup from "@/pages/company/menu/category-menu-group";
import CompanyBranches from "@/pages/company/branches.vue";
import Warehouse from "@/pages/warehouse/index.vue";
import WarehouseOld from "@/pages/warehouse/old.vue";
import CustomerReport from "@/pages/customer/report/index.vue";
import CustomerRestaurants from "@/pages/customer/restaurants/index.vue";
import CustomerHistory from "@/pages/customer/history.vue";
import MessageNotifications from "@/pages/notifications/messages.vue";
import Notifications from "@/pages/notifications/index.vue";
import FcmNotification from "@/pages/notifications/fcm.vue";
import EmailNotifications from "@/pages/notifications/email";
import FoodsQrList from "@/pages/qr/FoodsQrList.vue";
import CompanyQrList from "@/pages/qr/CompanyQrList.vue";
import GuestReport from "@/pages/guest/report.vue";
import UserProfile from "@/pages/user/profile.vue";
import UserLocation from "@/pages/user/location.vue";
import Suppliers from "@/pages/suppliers/index.vue";
import CanteenTesting from "@/pages/canteen/testing.vue";
import Canteen from "@/pages/canteen/index.vue";
import CanteenOld from "@/pages/canteen/old.vue";
import CanteenTemporary from "@/pages/canteen/temporary.vue";
import Posts from "@/pages/post/index.vue";
import QRlist from "@/pages/qr/list.vue";
import QRUser from "@/pages/qr/user.vue";
import Users from "@/pages/user/index.vue";
import UserGuestList from "@/pages/user/guests.vue";
import Delivery from "@/pages/delivery/index.vue";
import DeliveryOrders from "@/pages/delivery/orders.vue";
import HomeGuest from "@/pages/HomeGuest";
import GuestHome from "@/pages/GuestHome";
import Info from "@/pages/Info";
import CategoryMenuAdd from "@/pages/category-menu-add";
import Questionnaire from "@/pages/Questionnaire";
import AuthRoutes from '@/pages/auth'
import ReportRoutes from "@/pages/report/routes";

import store from "@/store/index";
import userService from "@/services/user";
Vue.use(VueRouter);

const routes = [
  ...AuthRoutes,
  ...ReportRoutes,
  {
    path: "/canteen",
    name: "canteen",
    displayName: "routes.canteen",
    icon: "mdi-cash-register",
    component: Canteen,
    roles: ["admin", "restaurant", "report", "recipient", "shop"],
  },
  {
    path: "/canteen-testing",
    name: "canteen-testing",
    displayName: "routes.canteen-testing",
    icon: "mdi-cash-register",
    component: CanteenTesting,
    roles: ["admin", "restaurant", "report", "recipient", "shop"],
  },
  {
    path: "/naplata2",
    name: "naplata2",
    displayName: "routes.canteen2",
    icon: "mdi-cash-multiple",
    component: CanteenTemporary,
    roles: ["admin", "restaurant", "report", "recipient", "shop"],
  },
  {
    path: "/guest-report",
    name: "guest-report",
    displayName: "routes.guest-report",
    icon: "mdi-account-group-outline",
    component: GuestReport,
    roles: ["report_guest", "restaurant", "admin"],
    permissions: ["can_report"],
  },
  {
    path: "/company-menu",
    name: "company-menu",
    displayName: "routes.company-menu",
    icon: "mdi-food-fork-drink",
    component: CompanyMenu,
    roles: ["customer", "company", "worker_more_restaurants"],
  },
  {
    path: "/guest",
    name: "guest",
    displayName: "routes.guest",
    icon: "mdi-account",
    component: HomeGuest,
    roles: ["guest", "company", "customer"],
  },
  {
    path: "/jela",
    name: "jela",
    displayName: "routes.jela",
    icon: "mdi-food",
    component: RestaurantFoods,
    roles: ["admin", "restaurant", "shop"],
  },
  {
    path: "/jelovnik",
    name: "jelovnik",
    displayName: "routes.jelovnik",
    icon: "mdi-book-open-page-variant",
    component: RestaurantMenu,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/restaurant-menu-groups",
    name: "restaurant-menu-groups",
    displayName: "routes.menu",
    icon: "mdi-menu",
    component: RestaurantMenuGroups,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/firme",
    name: "firme",
    displayName: "routes.firme",
    icon: "mdi-domain",
    component: Companies,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/firmeDostava",
    name: "firme-dostava",
    displayName: "routes.firme-dostava",
    icon: "mdi-truck-delivery",
    component: CompanyDelivery,
    roles: ["admin", "restaurant", "company", "dostava", "admin_delivery"],
    // 'company',
  },
  {
    path: "/delivery-user-orders",
    name: "delivery-user-orders",
    displayName: "routes.delivery-user-orders",
    icon: "mdi-truck",
    component: DeliveryOrders,
    roles: ["admin", "restaurant", "company", "dostava", "admin_delivery"],
  },
  {
    path: "/poslovnice",
    name: "poslovnice",
    displayName: "routes.poslovnice",
    icon: "mdi-store",
    component: CompanyBranches,
    roles: ["admin", "company"],
  },
  {
    path: "/restorani",
    name: "restorani",
    displayName: "routes.restorani",
    icon: "mdi-silverware-fork-knife",
    component: Restaurants,
    roles: ["admin", "restaurant", "dostava", "admin_delivery"],
  },
  {
    path: "/restaurants",
    name: "restorani-guest",
    displayName: "routes.restorani-guest",
    icon: "mdi-silverware-fork-knife",
    component: GuestRestaurants,
    roles: ["admin", "restaurant", "guest", "dostava"],
  },
  {
    path: "/firma/:id/korisnici",
    name: "firma-id-korisnici",
    displayName: "routes.firma-id-korisnici",
    icon: "mdi-account-multiple",
    component: Users,
    roles: ["admin", "restaurant", "company", "guest", "admin_delivery"],
  },
  {
    path: "/firma/:id/qrlist",
    name: "firma-id-qrlist",
    displayName: "routes.firma-id-qrlist",
    icon: "mdi-qrcode",
    component: CompanyQrList,
    roles: ["admin", "restaurant", "company", "guest", "admin_delivery"],
  },
  {
    path: "/foods/qrlist",
    name: "foods-qrlist",
    displayName: "routes.foods-qrlist",
    icon: "mdi-qrcode",
    component: FoodsQrList,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/restoran/:id/korisnici",
    name: "restoran-id-korisnici",
    displayName: "routes.restoran-id-korisnici",
    icon: "mdi-account-multiple",
    component: Users,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/restoran/:id/dostava",
    name: "restoran-dostava",
    displayName: "routes.restoran-dostava",
    icon: "mdi-truck-fast",
    component: RestaurantDelivery,
    roles: ["restaurant", "admin", "customer", "company", "guest"],
  },
  {
    path: "/korisnici",
    name: "korisnici",
    displayName: "routes.korisnici",
    icon: "mdi-account-group",
    component: Users,
    roles: ["company"],
  },
  {
    path: "/naplata",
    name: "naplata",
    displayName: "routes.naplata",
    icon: "mdi-cash",
    component: CanteenOld,
    roles: ["restaurant", "recipient", "payment"],
  },
  {
    path: "/guest-home",
    name: "guest-home",
    displayName: "routes.guest-home",
    icon: "mdi-home-account",
    component: GuestHome,
    roles: ["restaurant", "recipient"],
  },
  {
    path: "/company/report",
    name: "company-report",
    displayName: "routes.izvestajFirma",
    icon: "mdi-file-chart",
    component: CompanyReport,
    roles: ["company"],
  },
  {
    path: "/company/limits",
    name: "company-limits",
    displayName: "limits_settings",
    icon: "mdi-shield-account",
    component: CompanyLimits,
    roles: ["company", "admin"],
  },
  {
    path: "/company/:id/limits",
    name: "company-id-limits",
    displayName: "limits_settings",
    icon: "mdi-file-chart",
    component: CompanyLimits,
    roles: ["company", "restaurant", "admin"],
  },
  {
    path: "/restaurant/limits",
    name: "restaurant-limits",
    displayName: "limits_settings",
    icon: "mdi-shield-account",
    component: RestaurantLimits,
    roles: ["restaurant", "admin"],
  },
  {
    path: "/namirnice",
    name: "namirnice",
    displayName: "routes.namirnice",
    icon: "mdi-food-apple",
    component: RestaurantGroceries,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/delivery",
    name: "delivery",
    displayName: "routes.delivery",
    icon: "mdi-truck-delivery-outline",
    component: Delivery,
    roles: ["admin", "restaurant", "customer", "company"],
  },
  {
    path: "/suppliers",
    name: "suppliers",
    displayName: "routes.suppliers",
    icon: "mdi-truck",
    component: Suppliers,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/magacin",
    name: "magacin",
    displayName: "routes.magacin",
    icon: "mdi-warehouse",
    component: WarehouseOld,
    roles: ["admin", "restaurant", "warehouse"],
  },
  {
    path: "/restaurant/settings",
    name: "/restaurant/settings",
    displayName: "routes.podesavanja",
    icon: "mdi-cog",
    component: RestaurantSettings,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/galerija",
    name: "galerija",
    displayName: "routes.galerija",
    icon: "mdi-image-multiple",
    component: RestaurantGallery,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/kategorije",
    name: "kategorije",
    displayName: "routes.kategorije",
    icon: "mdi-shape",
    component: RestaurantMealCategories,
    roles: ["admin", "restaurant", "shop"],
  },
  {
    path: "/additional-meals",
    name: "additional-meals",
    displayName: "routes.additional_meals",
    icon: "mdi-food-variant",
    component: () => import("@/pages/additional-meals/index.vue"),
    roles: ["admin", "restaurant"],
  },
  {
    path: "/istorijat",
    name: "istorijat",
    displayName: "routes.istorijat",
    icon: "mdi-history",
    component: CustomerHistory,
    roles: ["customer"],
  },
  {
    path: "/lokacija",
    name: "lokacija",
    displayName: "routes.lokacija",
    icon: "mdi-map-marker",
    component: UserLocation,
    roles: ["customer", "company"],
  },
  {
    path: "/info",
    name: "info",
    displayName: "routes.info",
    icon: "mdi-information",
    component: Info,
    roles: [
      "admin",
      "restaurant",
      "customer",
      "company",
      "guest",
      "recipient",
      "report_guest",
    ],
  },
  {
    path: "/qrlist",
    name: "QRlist",
    displayName: "routes.QRlist",
    icon: "mdi-format-list-bulleted-square",
    component: QRlist,
    props: true,
    roles: ["admin", "restaurant", "company", "report_guest"],
  },
  {
    path: "/qrkod",
    name: "qrShow",
    displayName: "routes.qrShow",
    icon: "mdi-qrcode",
    component: QRUser,
    roles: ["admin", "restaurant", "company", "customer", "guest", "payment"],
  },
  {
    path: "/notification",
    name: "notification",
    displayName: "routes.notification",
    icon: "mdi-bell",
    component: Notifications,
    props: true,
    roles: ["admin", "restaurant", "company"],
  },
  {
    path: "/category-menu",
    name: "category-menu",
    displayName: "routes.category-menu",
    icon: "mdi-shape-outline",
    component: CategoryMenu,
    roles: ["admin", "restaurant", "guest", "company", "customer"],
  },
  {
    path: "/poruke",
    name: "poruke",
    displayName: "routes.poruke",
    icon: "mdi-message",
    component: MessageNotifications,
    roles: ["admin", "restaurant"],
  },
  {
    path: "/posts",
    name: "posts",
    displayName: "routes.posts",
    icon: "mdi-post",
    component: Posts,
    roles: ["admin"],
  },
  {
    path: "/fcm-notification",
    name: "fcm-notification",
    displayName: "routes.fcm-notification",
    icon: "mdi-bell-ring",
    component: FcmNotification,
    roles: ["admin", "restaurant", "company", "customer"],
  },
  {
    path: "/category-menu-group",
    name: "category-menu-group",
    displayName: "routes.category-menu-group",
    icon: "mdi-shape-plus",
    component: CategoryMenuGroup,
    roles: ["admin", "restaurant", "guest", "company", "customer"],
  },
  {
    path: "/category-menu-add",
    name: "category-menu-add",
    displayName: "routes.category-menu-add",
    icon: "mdi-shape-plus-outline",
    component: CategoryMenuAdd,
    roles: ["admin", "restaurant", "guest", "company", "customer"],
  },
  {
    path: "/questionnaire",
    name: "questionnaire",
    displayName: "routes.questionnaire",
    icon: "mdi-comment-question-outline",
    component: Questionnaire,
    roles: ["admin", "restaurant", "guest", "company", "customer"],
  },
  {
    path: "/users-guest-list",
    name: "users-guest-list",
    displayName: "routes.users-guest-list",
    icon: "mdi-account-multiple-outline",
    component: UserGuestList,
    roles: ["admin"],
  },
  {
    path: "/profil",
    name: "profil",
    displayName: "routes.profil",
    icon: "mdi-account-circle",
    component: UserProfile,
    roles: ["restaurant", "admin", "customer", "company", "guest", "recipient"],
  },
  {
    path: "/warehouse",
    name: "warehouse",
    displayName: "routes.warehouse",
    icon: "mdi-warehouse",
    component: Warehouse,
    roles: ["admin", "restaurant", "warehouse"],
  },
  {
    path: "/recipes",
    name: "recipes",
    displayName: "routes.recipes",
    icon: "mdi-food-variant",
    component: RestaurantRecipes,
    roles: ["admin", "restaurant", "warehouse"],
  },
  {
    path: "/customer/report",
    name: "customer-report",
    displayName: "routes.report",
    icon: "mdi-file-outline",
    component: CustomerReport,
    roles: ["customer"],
  },
  {
    path: "/customer/restaurants",
    name: "customer-restaurants",
    displayName: "routes.restaurants",
    icon: "mdi-store",
    component: CustomerRestaurants,
    roles: ["company"],
  },
  {
    path: "/send-email",
    name: "send-email",
    displayName: "routes.recipes",
    icon: "mdi-food-variant",
    component: EmailNotifications,
    roles: ["admin"],
  },
  /*{
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/!* webpackChunkName: "about" *!/ '@/views/About.vue')
  }*/
  // admin_delivery
];

const router = new VueRouter({
  //mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

// Helper to get all route permissions
export function allRoutes() {
  return routes.map((route) => ({
    name: route.name,
    displayName: route.displayName,
    icon: route.icon,
    roles: route.roles,
    permissions: route.permissions || [],
    rules: route.rules || [],
  }));
}

router.beforeEach((to, from, next) => {
  if (store.state.user.user) {
    let route = routes.find((i) => i.name === to.name);
    if (route && route.roles.includes(store.state.user.user.type)) next();
    else {
      let routeName = routes.find((i) => i.roles.includes(store.state.user.user.type));
      next({ name: routeName.name });
    }
  } else if (
    !store.state.user.user &&
    localStorage.getItem("restoran-token") &&
    to.name !== "auth-login"
  ) {
    userService
      .getCurrentUser()
      .then((res) => {
        store.commit("user/SAVE_USER", res.data);
        if (res.data.restaurants && res.data.restaurants.length) {
          store.commit("SAVE_RESTAURANT", res.data.restaurants[0]);
          store.commit("SAVE_COMPANY", null);
          store.commit("SAVE_COMPANIES", null);
        }
        if (res.data.companies && res.data.companies.length) {
          store.commit("SAVE_COMPANY", res.data.companies[0]);
          store.commit("SAVE_COMPANIES", res.data.companies);
          store.commit("SAVE_RESTAURANT", null);
        }
      })
      .then(() => {
        let route = routes.find((i) => i.name === to.name);
        if (!route) {
          let routeName = routes.find((i) =>
            i.roles.includes(store.state.user.user.type)
          );
          next({ name: routeName.name });
          //next({name:'jela'})
        }
        if (route && route.roles.includes(store.state.user.user.type)) {
          next();
        }
      });
  } else if (!store.state.user.user) {
    const noToken = !localStorage.getItem("restoran-token");
    const isPasswordRecoveryRoute =
      noToken &&
      (to.name === "auth-forgot-password" || to.name === "auth-reset-password");
    const isPublicGuestRoute =
      to.name === "auth-login" || to.name === "restorani-guest" || to.name === "guest";
    if (isPasswordRecoveryRoute || isPublicGuestRoute) {
      next();
    } else {
      next({ name: "auth-login" });
    }
  }
});

export default router;
